import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';
import logoSteam from '../../../_assets/steam.svg';
import psLogo from '../../../_assets/ps_logo.svg';
import xboxLogo from '../../../_assets/xbox_logo.svg';

interface Props {
  youtubeUrl: string;
  websiteUrl?: string;
  storesUrls: {
    playstation?: string;
    xbox?: string;
    steam: string;
  };
  isReleased? : boolean;
  hasMultiplePlatforms?: boolean,
}
export function GameTrailer(props: Props): JSX.Element {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const goToStore = (storeUrl: string): void => {
    setAnchorEl(null);
    if (storeUrl) {
      window.open(storeUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    if (props.hasMultiplePlatforms) {
      setAnchorEl(event.currentTarget);
    } else {
      goToStore(Object.values(props.storesUrls)[0]);
    }
  };
  const handleClose = (): void => {
    setAnchorEl(null);
  };

  return (
    <div className='game-content'>
      <div className='iframe-wrapper'>
        <iframe
          className='reponsive-iframe'
          src={props.youtubeUrl}
          title='YouTube video player'
          frameBorder='0'
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
          allowFullScreen
        />
      </div>
      <div className='button-group'>
        {props.websiteUrl && (
          <button
            type='button'
            className='btn btn-primary-game'
            onClick={() => { window.open(props.websiteUrl, '_blank', 'noopener,noreferrer'); }}
          >
            {t('button.discoverMore')}
          </button>
        )}

        <>
          <button
            type='button'
            id='stores-button'
            aria-controls={open ? 'stores-menu' : undefined}
            aria-haspopup='true'
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            className='btn btn-primary-game'
          >
            {props.isReleased ? t('button.getItNow') : t('button.wishlistNow') }
          </button>
          { props.hasMultiplePlatforms
          && (
            <Menu
              id='stores-menu'
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'stores-button',
              }}
            >
              <MenuItem
                disabled={!props.storesUrls?.steam}
                onClick={() => goToStore(props.storesUrls.steam)}
              >
                <img src={logoSteam} alt='steam' className='logo' />
                {t('button.stores.steam')}
                {!props.storesUrls.steam && (
                  <span className='soon'>
                    {t('account.provider.coming')}
                    !
                  </span>
                )}

              </MenuItem>
              <MenuItem
                disabled={!props.storesUrls?.playstation}
                onClick={() => goToStore(props.storesUrls.playstation)}
              >
                <img src={psLogo} alt='steam' className='logo' />
                {t('button.stores.playstation')}
                {!props.storesUrls.playstation && (
                  <span className='soon'>
                    {t('account.provider.coming')}
                    !
                  </span>
                )}

              </MenuItem>
              <MenuItem
                className={!props.storesUrls?.xbox ? 'disabled' : ''}
                onClick={() => goToStore(props.storesUrls.xbox)}
              >
                <img src={xboxLogo} alt='steam' className='logo' />
                {t('button.stores.microsoft')}
                {!props.storesUrls.xbox && (
                  <span className='soon'>
                    {t('account.provider.coming')}
                    !
                  </span>
                )}

              </MenuItem>
            </Menu>
          )}

        </>
      </div>
    </div>

  );
}
